import {
  ChangeDetectionStrategy,
  Component,
  input,
  inject,
} from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Module } from 'src/app/_models/module-enum';
import { IconNames } from '../../icons/icon-names';

@Component({
  selector: 'app-installed-modules-card',
  templateUrl: './installed-modules-card.component.html',
  styleUrl: './installed-modules-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InstalledModulesCardComponent {
  private readonly sanitizer = inject(DomSanitizer);

  /** List of active modules (required) */
  activeModules = input<number[]>([]);

  /** Custom svg width (optional, default: '25') */
  width = input<string>('25');

  /** Custom svg height (optional, default: '25') */
  height = input<string>('25');

  /** Custom viewbox dimensions (optional, default: '0 0 25 25') */
  customViewBox = input<string>(`0 0 25 25`);

  opticalDensity = IconNames.OpticalDensity;
  oxygen = IconNames.Oxygen;
  fluo = IconNames.Fluorescence;
  liquidControl = IconNames.LiquidControl;
  pH = IconNames.pH;
  sparging = IconNames.Sparging;

  // Makes the Module enum available in the template
  Module = Module;

  icon(iconName: string): SafeHtml {
    let pathString = '';
    pathString = iconName.toString();
    return this.sanitizer.bypassSecurityTrustHtml(pathString);
  }
}
